import { AxiosInstance, AxiosResponse } from 'axios';

import {
  GetAllGVOpportunitiesRequestPayload,
  GetAllGVOpportunitiesSuccessPayload,
  OpportunityKpisData,
} from 'pages/GVOpportunities/store/actions';

export default class GVOpportunitiesAPI {
  client: AxiosInstance;

  constructor(client: AxiosInstance) {
    this.client = client;
  }

  async getAllGVOpportunities(
    data: GetAllGVOpportunitiesRequestPayload,
  ): Promise<AxiosResponse<GetAllGVOpportunitiesSuccessPayload>> {
    return this.client.post(
      '/v2/organizations/deal-center/transaction-opportunities/',
      { ...data },
    );
  }

  async getOpportunityKpis(): Promise<
    AxiosResponse<{ success: boolean; data: OpportunityKpisData }>
  > {
    return this.client.post(
      '/v2/organizations/deal-center/opportunity-kpis/',
      {},
    );
  }
}
